import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import "./styles.css";
import axios from "axios";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function showTemperature(response) {
    setWeatherData({
      ready: true,
      coord: response.data.coordinates,
      temperature: Math.round(response.data.temperature.current),
      description: response.data.condition.description,
      date: new Date(response.data.time * 1000),
      humidity: response.data.temperature.humidity,
      wind: response.data.wind.speed,
      icon: response.data.condition.icon,
      city: response.data.city,
    });
  }

  function search() {
    const apiKey = "813b4c64t1fd5d0aee7063b04bcob356";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;

    axios.get(apiUrl).then(showTemperature);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search(city);
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <div className="container">
          <div className="border">
            <form onSubmit={handleSubmit} id="city-form">
              <input
                type="text"
                placeholder="City Search"
                id="city-search"
                onChange={handleCityChange}
                className="search-form"
              />
              <button type="submit" className="btn btn-secondary m-2">
                Search
              </button>
            </form>
            <WeatherInfo data={weatherData} />
            <WeatherForecast
              coordinates={weatherData.coord}
              icon={weatherData.icon}
              city={weatherData.city}
            />
          </div>
        </div>
      </div>
    );
  } else {
    search();
    return "Loading";
  }
}
